// extracted by mini-css-extract-plugin
module.exports = {"backButton":"PunchOutBackButton_backButton__IKYVR"};